import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncBrokenAgreement = loadable(
  () => import('./BrokenAgreement'),
  {
    fallback: <Loader />,
  },
);
